module.exports = __webpack_public_path__ + "img/climate_grid_mob.63afde57.svg";